import { useSelector } from 'react-redux';
import { Navigate, useSearchParams } from 'react-router-dom';
import { authService } from 'services';
import { Logo } from 'shared/Logo';
import { selectUser } from 'store/selectors';

import ExitIcon from '@eduzz/houston-icons/Exit';

import { AccountList } from './AccountList';
import { Modal, Container, Content, Exit } from './styles';

export const SelectAccount = () => {
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirectTo');

  const { accounts, userAccountSelected } = useSelector(selectUser);
  const hasCookieUserId = !!authService.getUserIdCookie();
  const shouldSkipPage = (hasCookieUserId || accounts.length === 1 || userAccountSelected) && !redirectTo;
  if (shouldSkipPage) {
    return <Navigate to='/orderbump' replace={true} />;
  }

  return (
    <Modal>
      <Container>
        <Logo />
        <Content>
          <span>Entrar como:</span>
          <AccountList accounts={accounts} />
          <Exit onClick={authService.logout}>
            <ExitIcon size={24} className='exitIcon' />
            <span>Sair</span>
          </Exit>
        </Content>
      </Container>
    </Modal>
  );
};
